export default {
    NEW_PROPERTY: 'initProperty',
    Get: {
        LIST_OF_PROPERTY_PICTURES: 'getListOfPropertyPictures',
        PROPERTY_PICTURE: 'propertyPicture',
    },
    Set: {
        LIST_OF_PROPERTY_PICTURES: 'setListOfPropertyPictures',
        INSERT_PROPERTY_PICTURES: 'insertPropertyPictures',
        UPDATE_PROPERTY_PICTURE: 'updatePropertyPicture',
        UPDATE_PROPERTY_ARRAY_PICTURE: 'updatePropertyArrayPicture',
        UPDATE_PROPERTY_ARRAY_PICTURE_ROOM: 'updatePropertyArrayPictureRoom',
        DELETE_PROPERTY_PICTURE: 'deletePropertyPicture',
        REODER_PROPERTY_PICTURE: 'reOderPropertyPicture',
        RESORT_PROPERTY_PICTURE: 'reSortPropertyPicture',
        REMOVE_PROPERTY_PICTURE: 'removePropertyPicture',
        MOVE_PROPERTY_PICTURE: 'movePropertyPicture',
        REPLACE_PROPERTY_PICTURE: 'replacePropertyPicture',
        REMOVE_MOVE_ALL_UN_UPLOAD_PROPERTY_PICTURE: 'removeAllUnUploadPropertyPicture'
    },
    Service: {
        LIST_OF_PROPERTY_PICTURES: 'listOfPropertyPictures',
    },
};